import { useAppDispatch } from 'client/hooks/use-dispatch'
import { setSettingsEditing } from 'client/store/management/managementActions'
import React from 'react'
import { PaletteIcon } from 'src/editor/shared/icons/palette-icon'
import { SecondaryButton } from 'src/editor/shared/ui-lib/buttons'
import { FormSubEntityTypeEnum } from 'src/shared/entities/form/enums'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export const FormSubEntityCommonSettingsButtonLink = ({
  formEntity,
  commonSettingsType,
}: {
  formEntity: FormInterface
  commonSettingsType: FormSubEntityTypeEnum
}) => {
  const { t } = useTypedTranslation()

  const dispatch = useAppDispatch()

  return (
    <SecondaryButton
      className="w-full"
      iconBefore={<PaletteIcon />}
      onClick={() =>
        dispatch(
          setSettingsEditing({
            id: formEntity.id,
            type: formEntity.type,
            subEntityId: undefined,
            commonSettingsType,
          }),
        )
      }
    >
      {t('entity_settings.form.link_to_common_settings')}
    </SecondaryButton>
  )
}
